const {KitModule, registerModule} = window;

class CareersList extends KitModule {
    constructor($element) {
        super($element);

        if (this.$filters) this.$filters.addEventListener('change', this);
    }

    onchange() {
        this.updateResults();
        this.resetScroll();
    }

    updateResults() {
        const departmentValue = this.$departmentsSelect.value;
        const locationValue = this.$locationsSelect.value;
        let visibleJobCount = 0;
        const isAll = (value) => value === 'All' || value === 'None' || value === 'all' || value === 'none';

        this.$departmentGroups.forEach(($group) => {
            // show or hide department
            const department = $group.getAttribute('data-department-group');
            if (isAll(departmentValue)) {
                $group.hidden = false;
            } else {
                const isGroupHidden = department !== departmentValue;
                $group.hidden = isGroupHidden;
                if (isGroupHidden) return;
            }

            // show or hide job
            const $jobs = $group.querySelectorAll('[data-js-children="$jobs"]');
            let visibleGroupJobCount = 0;
            $jobs.forEach(($job) => {
                const locationsAttr = $job.getAttribute('data-locations') || $job.getAttribute('data-location') || '';
                const jobLocations = locationsAttr.split('|').filter(Boolean);
                let isHidden;
                if (isAll(locationValue)) {
                    isHidden = false;
                } else {
                    isHidden = !jobLocations.includes(locationValue);
                }
                $job.hidden = isHidden;
                visibleGroupJobCount += isHidden ? 0 : 1;
            });
            // hide group with no matching jobs
            if (!visibleGroupJobCount) $group.hidden = true;
            visibleJobCount += visibleGroupJobCount;
        });

        // show no results if no visibleJob
        this.$noResultsMessage.hidden = visibleJobCount ? true : false;
    }

    resetScroll() {
    // grab fresh heights
        const htmlStyle = getComputedStyle(document.documentElement);
        const navEl = document.querySelector('.nav');
        let navHeight = navEl ? navEl.offsetHeight : 0;
        if (!navHeight) {
            navHeight = htmlStyle.getPropertyValue('--nav-height');
            if (String(navHeight).endsWith('rem')) {
                navHeight = parseInt(navHeight, 10) * parseInt(htmlStyle.fontSize, 10);
            }
        }

        // Reset scroll position to top of careers section
        const careersTop = (this.$element.getBoundingClientRect().top + document.documentElement.scrollTop) - parseInt(navHeight, 10);
        setTimeout(() => {
            window.scrollTo({
                top: careersTop,
                left: 0,
            });
        }, 150);
    }

    unmount() {
        if (this.$filters) this.$filters.removeEventListener('change', this);
    }
}

registerModule('CareersList', CareersList);
